import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';
import './styles.scss';

interface DeleteTradeModalProps {
  open: boolean;
  tradeId: string;
  handleClose: () => void;
  handleDelete: (tradeId: string) => void;
}

const DeleteTradeModal = ({ open, tradeId, handleClose, handleDelete }: DeleteTradeModalProps) => {
  const handleDeleteTrade = () => {
    handleDelete(tradeId);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="delete-trade-modal-container">
        <div className="delete-trade-modal-content">
          <div className="header">
            <h1>Are you sure you want to delete this trade?</h1>
            <Button className="close-button" onClick={handleClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>
          <div className="subtitle">All the data in this trade will be lost.</div>
          <div className="buttons">
            <Button className="cancel-button" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="delete-button" onClick={handleDeleteTrade}>
              Delete anyway
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTradeModal;
